/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Task_Sla_LabelInputs */

const en_task_sla_label = /** @type {(inputs: Task_Sla_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.days === 1 || i?.days === "1")) return /** @type {LocalizedString} */ (`1 business day`);
	if ((i?.days === 2 || i?.days === "2")) return /** @type {LocalizedString} */ (`2 business days`);
	if ((i?.days === 3 || i?.days === "3")) return /** @type {LocalizedString} */ (`3 business days`);
	if ((i?.days === 5 || i?.days === "5")) return /** @type {LocalizedString} */ (`5 business days`);
	if ((i?.days === 10 || i?.days === "10")) return /** @type {LocalizedString} */ (`10 business days`);
	return /** @type {LocalizedString} */ (`${i?.days}`)
	
};

const pt_br2_task_sla_label = /** @type {(inputs: Task_Sla_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.days === 1 || i?.days === "1")) return /** @type {LocalizedString} */ (`1 dia útil`);
	if ((i?.days === 2 || i?.days === "2")) return /** @type {LocalizedString} */ (`2 dias úteis`);
	if ((i?.days === 3 || i?.days === "3")) return /** @type {LocalizedString} */ (`3 dias úteis`);
	if ((i?.days === 5 || i?.days === "5")) return /** @type {LocalizedString} */ (`5 dias úteis`);
	if ((i?.days === 10 || i?.days === "10")) return /** @type {LocalizedString} */ (`10 dias úteis`);
	return /** @type {LocalizedString} */ (`${i?.days}`)
	
};

/**
* | days | output |
* | --- | --- |
* | "1" | "1 business day" |
* | "2" | "2 business days" |
* | "3" | "3 business days" |
* | "5" | "5 business days" |
* | "10" | "10 business days" |
* | * | "{days}" |
*
* @param {Task_Sla_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_sla_label = /** @type {((inputs: Task_Sla_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Sla_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_sla_label(inputs)
	return pt_br2_task_sla_label(inputs)
});